"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GraphQLError = exports.GraphQLResponse = exports.isGraphQLStdErr = void 0;
const sdk_network_1 = require("@ihr-radioedit/sdk-network");
exports.isGraphQLStdErr = (o) => typeof o === "object" && o.hasOwnProperty("message");
class GraphQLResponse {
    constructor(data, errors, extensions) {
        this.data = data;
        this.errors = errors;
        this.extensions = extensions;
    }
    static fromResponse({ data, errors, extensions, }) {
        return new GraphQLResponse(data, errors, extensions);
    }
    get hasError() {
        var _a, _b;
        return ((_b = (_a = this.errors) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0;
    }
    hasErrorCondition(condition) {
        return !!this.errors && this.errors.some(err => exports.isGraphQLStdErr(err) && err.message === condition);
    }
}
exports.GraphQLResponse = GraphQLResponse;
class GraphQLError extends sdk_network_1.ErrorBase {
    constructor(message, response) {
        super(message);
        this.message = message;
        this.response = response;
        this.name = "GraphQL Error";
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, GraphQLError);
        }
    }
}
exports.GraphQLError = GraphQLError;
//# sourceMappingURL=response.js.map